/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import { emailValidator, REGEX_PASSWORD } from "@advapacs/common";
import SimpleReactValidator from "simple-react-validator";
import { TFunction } from "i18next";

interface IUpdatePasswordForm {
  password: string;
  confirmPassword: string;
}

const getUpdatePasswordValidator = (t: TFunction): SimpleReactValidator => {
  return new SimpleReactValidator({
    messages: {
      required: `${t("form:validation.required")}`,
    },
    validators: {
      passwordPattern: {
        message: `${t("error_messages.password_invalid")}`,
        rule: (password: string) => {
          return REGEX_PASSWORD.test(password);
        },
        // @ts-ignore
        required: true,
      },
      comparePassword: {
        message: `${t("error_messages.password_same_value")}`,
        rule: ({ password, confirmPassword }: IUpdatePasswordForm) => {
          return password === confirmPassword;
        },
        // @ts-ignore
        required: true,
      },
      ...emailValidator(t),
    },
  });
};

export default getUpdatePasswordValidator;
